export const PRESCRIPTION_REQUEST = 'PRESCRIPTION_REQUEST';
export const PRESCRIPTION_REQUEST_SUCCESS = 'PRESCRIPTION_REQUEST_SUCCESS';
export const PRESCRIPTION_REQUEST_ERROR = 'PRESCRIPTION_REQUEST_ERROR';

export const CLICKED_PRESCRIPTION_ID = 'CLICKED_PRESCRIPTION_ID';

export const PRESCRIPTION_NO = 'PRESCRIPTION_NO';

export const PRESCRIPTION_IMAGE_OPEN = 'PRESCRIPTION_IMAGE_OPEN';